'use strict';

require('../../style/index.less');

require('./index.less');

require('../../layout/style');


/*****************
 ** WEBPACK FOOTER
 ** ./components/form/style/index.js
 ** module id = 216
 ** module chunks = 0
 **/